function Footer() {
  return (
    <footer className="py-2">
      <div className="flex flex-col items-center justify-between gap-4 md:h-8 md:flex-row">
        <p className="text-balance text-center text-sm leading-loose text-muted-foreground">
          Built by{" "}
          <a
            href="https://chromewebstore.google.com/detail/asktube-ai-youtube-video/kkdhnobdacfnbdageilfchkhcjdbkhgf"
            target="_blank"
            rel="noreferrer"
            className="font-medium underline underline-offset-4"
          >
            AskTube
          </a>
          .
        </p>
      </div>
    </footer>
  );
}

export default Footer;
